import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImageIcon, Languages, Mic, Video } from 'lucide-react';

const SERVICES = [
  { key: 'translation', Icon: Languages },
  { key: 'image', Icon: ImageIcon },
  { key: 'voice', Icon: Mic },
  { key: 'video', Icon: Video },
] as const;

export const ServicesSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-[#f8fafc] text-slate-950">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 md:grid-cols-[0.85fr_1.15fr] md:px-8">
        <div>
          <p className="text-sm font-semibold uppercase text-teal-700">
            {t('landing.services.eyebrow')}
          </p>
          <h2 className="mt-3 text-3xl font-bold leading-tight md:text-4xl">
            {t('landing.services.title')}
          </h2>
          <p className="mt-4 text-base leading-7 text-slate-600">
            {t('landing.services.description')}
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {SERVICES.map(({ key, Icon }) => (
            <article key={key} className="rounded-lg border border-slate-200 bg-white p-5">
              <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-slate-950 text-white">
                <Icon size={20} />
              </div>
              <h3 className="text-base font-semibold">
                {t(`landing.services.items.${key}.title`)}
              </h3>
              <p className="mt-3 text-sm leading-6 text-slate-600">
                {t(`landing.services.items.${key}.description`)}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
